export default {"src":"/_next/static/media/list-view-icon.f972a710.svg","height":22,"width":27,"blurWidth":0,"blurHeight":0};